import {
  CUSTOM_DROPDOWN_VALUE_CHAR_LIMIT,
  CUSTOM_STATUS_NAME_CHART_LIMIT,
} from "./consts";

export const customFieldNameValidator = (name: string) =>
  name.trim().length > 0;

export const customDropdownValueValidator = (value: string) =>
  value.trim().length > 0 &&
  value.trim().length <= CUSTOM_DROPDOWN_VALUE_CHAR_LIMIT;

export const customStatusNameValidator = (name: string) =>
  name.trim().length > 0 &&
  name.trim().length <= CUSTOM_STATUS_NAME_CHART_LIMIT;
